/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScheduleOfValuesResponseDto } from './ScheduleOfValuesResponseDto';
import {
    ScheduleOfValuesResponseDtoFromJSON,
    ScheduleOfValuesResponseDtoFromJSONTyped,
    ScheduleOfValuesResponseDtoToJSON,
    ScheduleOfValuesResponseDtoToJSONTyped,
} from './ScheduleOfValuesResponseDto';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';

/**
 * 
 * @export
 * @interface ScheduleOfValuesPaginationResponseDto
 */
export interface ScheduleOfValuesPaginationResponseDto {
    /**
     * 
     * @type {PaginationDto}
     * @memberof ScheduleOfValuesPaginationResponseDto
     */
    pagination: PaginationDto;
    /**
     * 
     * @type {Array<ScheduleOfValuesResponseDto>}
     * @memberof ScheduleOfValuesPaginationResponseDto
     */
    items: Array<ScheduleOfValuesResponseDto>;
    /**
     * 
     * @type {string}
     * @memberof ScheduleOfValuesPaginationResponseDto
     */
    fileId?: string;
}

/**
 * Check if a given object implements the ScheduleOfValuesPaginationResponseDto interface.
 */
export function instanceOfScheduleOfValuesPaginationResponseDto(value: object): value is ScheduleOfValuesPaginationResponseDto {
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function ScheduleOfValuesPaginationResponseDtoFromJSON(json: any): ScheduleOfValuesPaginationResponseDto {
    return ScheduleOfValuesPaginationResponseDtoFromJSONTyped(json, false);
}

export function ScheduleOfValuesPaginationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduleOfValuesPaginationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pagination': PaginationDtoFromJSON(json['pagination']),
        'items': ((json['items'] as Array<any>).map(ScheduleOfValuesResponseDtoFromJSON)),
        'fileId': json['fileId'] == null ? undefined : json['fileId'],
    };
}

export function ScheduleOfValuesPaginationResponseDtoToJSON(json: any): ScheduleOfValuesPaginationResponseDto {
    return ScheduleOfValuesPaginationResponseDtoToJSONTyped(json, false);
}

export function ScheduleOfValuesPaginationResponseDtoToJSONTyped(value?: ScheduleOfValuesPaginationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pagination': PaginationDtoToJSON(value['pagination']),
        'items': ((value['items'] as Array<any>).map(ScheduleOfValuesResponseDtoToJSON)),
        'fileId': value['fileId'],
    };
}

